import arraySort from 'array-sort'
import { compareTwoValues } from './compare-two-values'
import dotProp from 'dot-prop'

/**
 * Sort a list of objects using schema sort definitions and query
 * filter parameters.
 * @param {Array.<Object>} objects List of objects to sort.
 * @param {Array.<String>} sortableColumns The ordered list of key names to sort by.
 * @param {Boolean} [sortDescending] Whether to invert the sort order.
 * @return {Array.<Object>} The sorted list of objects.
 */
export default function sortArrayByObjectProperties({ objects, sortableColumns, sortDescending }) {
    function compare(prop) {
        return (a, b) => {
            if (sortDescending) {
                return compareTwoValues(dotProp.get(b, prop), dotProp.get(a, prop))
            } else {
                return compareTwoValues(dotProp.get(a, prop), dotProp.get(b, prop))
            }
        }
    }

    if (sortableColumns && sortableColumns.length) {
        const sortFunctions = sortableColumns.map(value => compare(value))
        return arraySort(objects, sortFunctions, null)
    } else {
        return objects
    }
}
